import {BaseRestService} from './base-rest.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from './app-settings.service';
import {OrderFilter} from '../../order/models/order-filter';
import {Observable} from 'rxjs';
import {ArrayResponse, SendBackResult, serializeQueryString, SharedModule} from '..';
import {Order} from '../../order/models/order';

@Injectable({providedIn: SharedModule})
export class MyOrdersService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'OrdersService'; }

  protected get isAnonymous(): boolean { return false; }

  getList( filter: OrderFilter): Observable<SendBackResult<ArrayResponse<Order>>> {
    return this.get<ArrayResponse<Order>>(`/Orders${serializeQueryString(filter)}`);
  }
}
